<template>
<div class="d-flex min-vh-100">
    <Aside />
    <main class="flex-grow-1 bg-light">
        <div class="p-4">
            <!-- Gestion des Articles -->
            <h2 class="mb-4">Gestion des Articles</h2>
            <div class="card shadow-sm p-4">
                <div v-if="articles.length > 0">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th>Titre</th>
                                <th>Catégorie</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="article in articles" :key="article.id">
                                <td>{{ article.title }}</td>
                                <td>{{ article.category }}</td>
                                <td>
                                    <button class="btn btn-primary btn-sm" @click="editArticle(article)">Éditer</button>
                                    <button class="btn btn-danger btn-sm" @click="deleteArticle(article.id)">Supprimer</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div v-else>
                    <p>Aucun article trouvé.</p>
                </div>
            </div>

            <!-- Modal d'édition pour les articles -->
            <div v-if="editingArticle" class="modal fade show d-block" tabindex="-1" style="display: block;">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Modifier l'Article</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="closeEditArticleModal"></button>
                        </div>
                        <div class="modal-body">
                            <form @submit.prevent="handleArticleUpdate">
                                <div class="mb-3">
                                    <label for="article_title" class="form-label">Titre</label>
                                    <input type="text" id="article_title" v-model="editingArticle.title" class="form-control" required />
                                </div>
                                <div class="mb-3">
                                    <label for="article_description" class="form-label">Description</label>
                                    <textarea id="article_content" v-model="editingArticle.content" class="form-control" required></textarea>
                                </div>
                                <div class="mb-3">
                                    <label for="article_category" class="form-label">Catégorie</label>
                                    <select id="article_category" v-model="editingArticle.category" class="form-select" required>
                                        <option v-for="cat in categories" :key="cat" :value="cat">{{ cat }}</option>
                                    </select>
                                </div>
                                <div class="mb-3">
                                    <label for="article_category" class="form-label">Cover</label>
                                    <input type="file" id="article_cover" @change="handleFileUpload" class="form-control" />
                                </div>

                                <button type="submit" class="btn btn-primary">Mettre à jour</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</div>
</template>
<script>
import axios from '@/api/axios.js';
import Aside from '@/components/Aside.vue';
import Swal from 'sweetalert2';

export default {
    components: {
        Aside
    },
    data() {
        return {
            articles: [], // Liste des articles
            editingArticle: null, // Article à éditer
            categories: [
                'Politics', 'Science', 'Environment', 'Sports', 'Culture', 'History', 'Art', 'Food',
                'Business', 'Fashion', 'Music', 'Gaming', 'Automotive', 'Space', 'Legal', 'Opinion',
                'Technology Reviews', 'Startups', 'Mental Health', 'Travel Tips'
            ]
        };
    },
    mounted() {
        this.fetchArticles();
    },
    methods: {
        // Récupérer les articles depuis l'API
        fetchArticles() {
            axios.get('/get-articles-search')
                .then(response => {
                    this.articles = response.data.data;
                })
                .catch(error => {
                    console.error('Erreur lors de la récupération des articles:', error);
                });
        },

        // Ouvrir le modal pour éditer un article
        editArticle(article) {
            this.editingArticle = {
                ...article
            }; // Cloner l'article pour l'édition
        },

        // Fermer le modal d'édition pour l'article
        closeEditArticleModal() {
            this.editingArticle = null;
        },

        // Gérer le téléchargement du fichier image
        handleFileUpload(event) {
            const file = event.target.files[0]; // Récupère le fichier sélectionné

            if (file) {
                const allowedTypes = ['image/jpeg', 'image/png', 'image/gif']; // Types d'image autorisés

                if (!allowedTypes.includes(file.type)) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Type de fichier non valide',
                        text: 'Veuillez télécharger une image au format JPEG, PNG ou GIF.',
                    });
                    return;
                }

                this.editingArticle.cover = file; // Met à jour l'image de couverture
            } else {
                this.editingArticle.cover = null; // Si aucun fichier n'est sélectionné, on ne modifie pas l'image
            }
        },

        // Mettre à jour un article
        handleArticleUpdate() {
            const formData = new FormData();
            formData.append('_method', 'put'); // Simulation de la méthode PUT
            formData.append('title', this.editingArticle.title);
            formData.append('content', this.editingArticle.content);
            formData.append('category', this.editingArticle.category);

            // Si un fichier est sélectionné, ajoutez-le
            if (this.editingArticle.cover) {
                formData.append('cover', this.editingArticle.cover);
            }

            axios.post(`/update-article/${this.editingArticle.id}`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data' // Important pour envoyer le fichier
                    }
                })
                .then(response => {
                    this.fetchArticles();
                    this.closeEditArticleModal();
                    Swal.fire({
                        icon: 'success',
                        title: 'Article mis à jour',
                        text: 'L\'article a été mis à jour avec succès.',
                    });
                })
                .catch(error => {
                    console.error('Erreur lors de la mise à jour de l\'article:', error);
                    Swal.fire({
                        icon: 'error',
                        title: 'Erreur',
                        text: 'Erreur lors de la mise à jour de l\'article.',
                    });
                });
        },

        // Supprimer un article
        deleteArticle(id) {
            Swal.fire({
                title: 'Êtes-vous sûr?',
                text: "Vous ne pourrez pas revenir en arrière!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Oui, supprimer!',
                cancelButtonText: 'Annuler',
            }).then((result) => {
                if (result.isConfirmed) {
                    axios.delete(`/delete-article/${id}`)
                        .then(() => {
                            this.fetchArticles();
                            Swal.fire({
                                icon: 'success',
                                title: 'Article supprimé',
                                text: 'L\'article a été supprimé avec succès.',
                            });
                        })
                        .catch(error => {
                            console.error('Erreur lors de la suppression de l\'article:', error);
                            Swal.fire({
                                icon: 'error',
                                title: 'Erreur',
                                text: 'Erreur lors de la suppression de l\'article.',
                            });
                        });
                }
            });
        }
    }
};
</script>
